<p class="alert alert-danger" role="alert" *ngIf="ErrorMessage">{{ErrorMessage}}</p>
<div class="row" *ngIf="Switcher_view==-1">
  <div class="col-xl-4 mb-30">

    <div class="card card-statistics">
      <div class="card-body">
        <div class="card-title">
          <div class="float-right">
            <select aria-label="نمایش تیکت‌ها" class="custom-select" (change)="ReadData_Ticket()"
              [(ngModel)]="Show_Draft_Ticket" name="Show_Draft_Ticket">
              <option value="0">همه موارد</option>
              <option value="1">منتظر پاسخ</option>
            </select>
          </div>

          <h6 *ngIf="!Proccessing">تیکت ها ({{Ticket_Datalist.length}} مورد)</h6>
          <h6 *ngIf="Proccessing">تیکت ها (در حال بارگذاری ...)</h6>
        </div>

        <!-- action group -->

        <div class="scrollbar" style="max-height: 500px;">
          <ul class="list-unstyled">
            <li class="ticket-empty text-muted" *ngIf="!Proccessing && Ticket_Datalist.length === 0">تیکتی برای نمایش
              وجود ندارد.</li>
            <li class="mb-15 ticket-choice" role="button" tabindex="0" [attr.aria-pressed]="item.selected"
              (keydown.enter)="ReadData_Ref_Ticket(item)"
              (keydown.space)="$event.preventDefault(); ReadData_Ref_Ticket(item)" *ngFor="let item of Ticket_Datalist
          | paginate: {
              id: 'DataList_FeildTable',
              itemsPerPage: 6,
              currentPage: page,
              totalItems: Ticket_Datalist.length
            }" style="cursor: pointer;" (click)="ReadData_Ref_Ticket(item)">
              <div class="media">

                <div class="media-body">
                  <h6 *ngIf="!item.selected" class="mt-0 "> {{item.title}} <small
                      style="color: blue;font-weight: bolder;" *ngIf="item.isNew" class="float-right">جدید</small> </h6>
                  <h6 *ngIf="item.selected" style="text-decoration: underline;font-style: italic;font-weight: bold;"
                    class="mt-0 "> {{item.title}} </h6>
                  <p>{{item.cateTitle}} <small class="float-right"> تیکت شماره {{item.code}}</small> </p>
                  <span class="badge" [ngClass]="{
        'badge-secondary': item.statusType === 'closed',
        'badge-warning': item.statusType === 'waiting-customer',
        'badge-info': item.statusType === 'waiting-behfa'
      }">
                    {{ item.statusText }}
                  </span>
                  <small>{{item.persianData}}</small>
                </div>
              </div>
              <div class="divider mt-15"></div>
            </li>

          </ul>
        </div>
        <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی"
          (pageChange)="page = $event"></pagination-controls>
        <button *ngIf="typeUser=='3' || typeUser=='4'" routerLink="/TicketForm" type="button" class="btn btn-success"><i
            class="fa fa-plus-circle"></i> ثبت تیکت جدید </button>
        <button *ngIf="typeUser=='1' || typeUser=='2'" routerLink="/TicketAdminForm" type="button"
          class="btn btn-success"><i class="fa fa-plus-circle"></i> ثبت تیکت جدید </button>
      </div>
    </div>
  </div>
  <div class="col-xl-8 mb-30">

    <div class="card tickets">
      <div class="card-body">
        <h5 class="card-title" *ngIf="Seleted_Ticket_Item.id>0">گفتگوی های تیکت 'شماره ی {{Seleted_Ticket_Item.code}} '
        </h5>
        <h5 class="card-title" *ngIf="Seleted_Ticket_Item.id==0">گفتگوی های تیکت 'تیکتی انتخاب نشده است'</h5>

        <button *ngIf="Seleted_Ticket_Item.id>0 && canReply" (click)="Show_View_ReplyForm()" type="button"
          class="btn btn-info"><i class="fa fa-plus"></i> پاسخ به تیکت </button>
        <br />
        <br />
        <div class="scrollbar max-h-550 tickets-info">
          <p class="ticket-empty text-muted" role="status" *ngIf="Proccessing_Ref">در حال دریافت گفتگو…</p>
          <p class="ticket-empty text-muted" *ngIf="!Proccessing_Ref && Seleted_Ticket_Item.id === 0">برای مشاهده گفتگو،
            یک تیکت انتخاب کنید.</p>
          <ul class="list-unstyled ticket-conversation" *ngIf="Seleted_Ticket_Item.id>0">
            <li class="mb-15" *ngFor="let item of Ticket_Datalist_Ref">
              <div class="media">
                <div class="position-relative">
                  <img class="img-fluid mr-15 avatar-small" src="{{BaseUrl}}{{item.image}}" alt="">
                  <i class="avatar-online bg-success"></i>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 "> {{item.fullname}} <small class="float-right">{{item.persianDate}}</small> </h6>

                  <div innerHTML="{{item.message}}"></div>

                  <div class="ticket-attachments" *ngIf="item.files && item.files.length > 0">
                    <div class="ticket-attachments__header">
                      <i class="fa fa-paperclip"></i>
                      <span>پیوست‌ها</span>
                      <span class="ticket-attachments__count">{{ item.files.length }}</span>
                    </div>

                    <div class="ticket-attachments__list">
                      <a *ngFor="let file of item.files; let i = index; trackBy: trackByFile"
                        class="ticket-attachment-card" target="_blank" [href]="BaseUrl + 'File/Ticket/' + file">
                        <div class="ticket-attachment-card__icon">
                          <i class="fa fa-file"></i>
                        </div>

                        <div class="ticket-attachment-card__content">
                          <div class="ticket-attachment-card__title">
                            {{ getTicketFileName(file) || ('فایل شماره ' + (i + 1)) }}
                          </div>
                          <div class="ticket-attachment-card__meta">
                            <span>پیوست {{ i + 1 }}</span>
                            <span class="dot">•</span>
                            <span>{{ getTicketFileExtension(file) }}</span>
                          </div>
                        </div>

                        <div class="ticket-attachment-card__action">
                          <i class="fa fa-download"></i>
                          <span>دانلود</span>
                        </div>
                      </a>
                    </div>
                  </div>

                </div>

              </div>
              <div class="divider mt-15"></div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<app-TicketReply *ngIf="Switcher_view==0" [canReply]="canReply" (OnBack_Ticket_Action)="OnGet_Back_Ticket($event)"
  [Ticket_Selected]="Seleted_Ticket_Item">

</app-TicketReply>